import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill, EyeFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddRole from "./AddRole";
import { toast } from "react-toastify";
import { log } from "console";
// import ViewCustomer from "./ViewCustomer";

export interface UserInterface {
  _id: number;
  roleName: string;
  permission: string;
  description: string;
}

const columns = [
  {
    id: "roleName",
    label: "Role Name",
    minWidth: 170,
    sortable: false,
  },
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as const,
  },
];

const Roles = () => {
  const [showAdminBlade, setShowAdminBlade] = useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState<string | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    fullName: "fullName",
    email: "email",
  };
  const [showBlade, setShowBlade] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const [userObject, setUserObject] = useState<UserInterface | null>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getRoleList(searchRef.current);
  }, [currentPage, sortField, sortOrder]);
  const getRoleList = (keyword: string = "") => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `role/list?${params.toString()}`,
    })
      .then((res: any) => {
             const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => {
             console.log("role", item.roleName);    
          return {
             
            ...item,
    
            roleName: item.roleName || "-",
            // phone: item.phone || "-",
            createdAt: HelperService.getFormatedDate(item.createdAt),
            action: (
              <div>
                {" "}
                 {/* {perm.canEdit && (  */}
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowBlade(true);
                      setSelectedRole(item);
                  }}
                 
                  title="Edit"
                /> 
                {/* )}  */}
                 {perm.canDelete && (
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(item._id)}
                  title="Delete"
                /> )}
              </div>
            ),
          };
        });
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {
        console.error("Error fetching admin roles:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDeleteEvent = (Id: string) => {
    setUserToDelete(Id);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddRole
        show={showBlade}
        handleClose={() => {
          setShowBlade(false);
          setSelectedRole(null);
          getRoleList(searchRef.current);
        }}
        data={selectedRole}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (userToDelete) {
            WebService.deleteAPI({
              action: `role/delete/${userToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              toast.success("Role deleted successfully.");
              getRoleList(searchRef.current);
            });
          }
        }}
        message="Are you sure you want to delete ?"
      />

      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Manage Roles</div>
            
             {pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setSelectedRole(null);
                setShowBlade(true);
              }}
              style={{ width: 120 }}
            /> )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;                  
                  setSearch(value);
                  setCurrentPage(1);
                  getRoleList(searchRef.current);
                }}
              />
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Roles;
